"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavETHPoolSubPackage = void 0;
const savETHPool_1 = require("../logic/savETHPool");
class SavETHPoolSubPackage {
    constructor(signer, savETHPoolAddress) {
        this.etherSigner = signer;
        this.savETHPoolAddress = savETHPoolAddress;
    }
    getIndexOwnedByTheVault() {
        return (0, savETHPool_1._getIndexOwnedByTheVault)(this.etherSigner, this.savETHPoolAddress);
    }
    batchDepositETHForStaking(blsPublicKeys, amounts, ethValue) {
        return (0, savETHPool_1._batchDepositETHForStaking)(this.etherSigner, this.savETHPoolAddress, blsPublicKeys, amounts, ethValue);
    }
    depositETHForStaking(blsPublicKey, amount, ethValue) {
        return (0, savETHPool_1._depositETHForStaking)(this.etherSigner, this.savETHPoolAddress, blsPublicKey, amount, ethValue);
    }
    burnLPTokens(lpTokens, amounts) {
        return (0, savETHPool_1._burnLPTokens)(this.etherSigner, this.savETHPoolAddress, lpTokens, amounts);
    }
    burnLPToken(lpToken, amount) {
        return (0, savETHPool_1._burnLPToken)(this.etherSigner, this.savETHPoolAddress, lpToken, amount);
    }
    isDETHReadyForWithdrawal(lpToken) {
        return (0, savETHPool_1._isDETHReadyForWithdrawal)(this.etherSigner, this.savETHPoolAddress, lpToken);
    }
    getdETHRequiredToIsolateWithdrawnKnot(blsPublicKey) {
        return (0, savETHPool_1._getdETHRequiredToIsolateWithdrawnKnot)(this.etherSigner, this.savETHPoolAddress, blsPublicKey);
    }
    depositDETHForStaking(blsPublicKey, amount) {
        return (0, savETHPool_1._depositDETHForStaking)(this.etherSigner, this.savETHPoolAddress, blsPublicKey, amount);
    }
    approveProtectedStakingPoolToTransferDETH(amount) {
        return (0, savETHPool_1._approveProtectedStakingPoolToTransferDETH)(this.etherSigner, this.savETHPoolAddress, amount);
    }
    previewPartialETHWithdrawalAmount(user, lpTokens) {
        return (0, savETHPool_1._previewPartialETHWithdrawalAmount)(this.etherSigner, this.savETHPoolAddress, user, lpTokens);
    }
    batchPartialWithdrawal(lpTokens, amounts) {
        return (0, savETHPool_1._batchPartialWithdrawal)(this.etherSigner, this.savETHPoolAddress, lpTokens, amounts);
    }
    partialWithdrawal(lpToken, amount) {
        return (0, savETHPool_1._partialWithdrawal)(this.etherSigner, this.savETHPoolAddress, lpToken, amount);
    }
    batchClaimETHFromRageQuit(lpTokens, amounts) {
        return (0, savETHPool_1._batchClaimETHFromRageQuit)(this.etherSigner, this.savETHPoolAddress, lpTokens, amounts);
    }
    claimETHFromRageQuit(lpToken, amount) {
        return (0, savETHPool_1._claimETHFromRageQuit)(this.etherSigner, this.savETHPoolAddress, lpToken, amount);
    }
}
exports.SavETHPoolSubPackage = SavETHPoolSubPackage;
